// Manage Account card icons — the four lever glyphs (Slider / Compass / Scale /
// Swap) plus a couple of domain markers. Screen-specific, so they live in the
// module, not the shared icon set. stroke=currentColor → they inherit tone.
// Generic icons (check, info, arrow, lock, clock) come from components/icons.

export const SliderIcon = (p) => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" {...p}>
    <line x1="4" y1="8" x2="20" y2="8" />
    <circle cx="9" cy="8" r="2.5" />
    <line x1="4" y1="16" x2="20" y2="16" />
    <circle cx="15" cy="16" r="2.5" />
  </svg>
);

export const CompassIcon = (p) => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" {...p}>
    <circle cx="12" cy="12" r="9" />
    <polygon points="15.5 8.5 10 10 8.5 15.5 14 14" />
  </svg>
);

export const ScaleIcon = (p) => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" {...p}>
    <path d="M12 3v18" />
    <path d="M5 21h14" />
    <path d="M6 3h12" />
    <path d="M3 9l3-6 3 6a3 3 0 0 1-6 0z" />
    <path d="M15 9l3-6 3 6a3 3 0 0 1-6 0z" />
  </svg>
);

export const SwapIcon = (p) => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" {...p}>
    <polyline points="17 1 21 5 17 9" />
    <path d="M3 11V9a4 4 0 0 1 4-4h14" />
    <polyline points="7 23 3 19 7 15" />
    <path d="M21 13v2a4 4 0 0 1-4 4H3" />
  </svg>
);

export const ClockIcon = (p) => (
  <svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
    <circle cx="12" cy="12" r="9" />
    <polyline points="12 7 12 12 15 14" />
  </svg>
);

export const AutoUpIcon = (p) => (
  <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
    <path d="M3 12a9 9 0 0 1 15.5-6.3M21 12a9 9 0 0 1-15.5 6.3" />
    <polyline points="14 4 18.5 5.7 17 10" />
    <polyline points="10 20 5.5 18.3 7 14" />
  </svg>
);
